import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone } from '../../../../utils/helpers.utils';
import {
    getInventoryOrderHistory,
    setInventoryOrderHistoryError,
    setInventoryOrderHistoryColSearchStr,
    setInventoryOrderHistoryPageSize,
    resetInventoryOrderHistory
} from '../../../../constants/model-reducers/external/inventory/circuit-details/order-history.settings';
import { convertToFormatLocalDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    isInventoryOrderHistoryLoaded: false,
    isInventoryOrderHistoryError: false,
    inventoryOrderHistoryItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryOrderHistoryIsSortedAsc: true,
});

const initialState = defaultState();

export const inventoryOrderHistoryActions = {
    getInventoryOrderHistory: (circuitID, pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryOrderHistory.inventoryOrderHistoryItems;
        try {
            var formData = {
                CircuitID: circuitID,
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: '',
                TableFilterList: [],
                TimeZone: getLocalTimeZone()
            };

            var orderHistoryItems = await httpPost('external/inventory/getAllOderHistoryItems', formData);

            dispatch({
                type: getInventoryOrderHistory,
                orderHistoryItems: Object.keys(orderHistoryItems).length > 0 ? orderHistoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryOrderHistoryLoaded: true,
                isInventoryOrderHistoryError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryOrderHistoryError,
                isInventoryOrderHistoryError: true,
                isInventoryOrderHistoryLoaded: false
            });
        }
    },
    setInventoryOrderHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryOrderHistoryItems } = state().inventoryOrderHistory;
        var inventoryOrderHistoryItemsUpd = {
            ...inventoryOrderHistoryItems,
            "Headers": {
                ...inventoryOrderHistoryItems.Headers,
                [key]: {

                    ...inventoryOrderHistoryItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryOrderHistoryColSearchStr,
            data: inventoryOrderHistoryItemsUpd
        });
    },

     extractOrderHistory: (circuitID) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryOrderHistory.inventoryOrderHistoryItems;
        const { activeDateFormat } = state().adminSetting;

        var filename = `ATEM Circuit Order History – ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;
        var formData = {
            CircuitID: circuitID,
            PageFilter: {
                PageIndex: 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            FileName: filename,
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: '',
            TableFilterList: [],
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/inventory/getExtractOrderHistory', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    resizeInventoryOrderHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInventoryOrderHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    resetInventoryOrderHistory: () => (dispatch, state) => {
        dispatch({
            type: resetInventoryOrderHistory
        })
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryOrderHistory:
            return {
                ...state,
                inventoryOrderHistoryItems: action.orderHistoryItems,
                isInventoryOrderHistoryLoaded: action.isInventoryOrderHistoryLoaded,
                isInventoryOrderHistoryError: action.isInventoryOrderHistoryError
            };
        case setInventoryOrderHistoryError:
            return {
                ...state,
                isInventoryOrderHistoryError: action.isInventoryOrderHistoryError,
                isInventoryOrderHistoryLoaded: action.isInventoryOrderHistoryLoaded
            }
        case setInventoryOrderHistoryColSearchStr:
            return {
                ...state,
                inventoryOrderHistoryItems: action.data
            }
        case setInventoryOrderHistoryPageSize:
            return {
                ...state,
                inventoryOrderHistoryItems: {
                    ...state.inventoryOrderHistoryItems,
                    Pagination: {
                        ...state.inventoryOrderHistoryItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case resetInventoryOrderHistory:
            return initialState;
        default:
            return state;
    }
};